import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-sso-right",
  "use": "icon-sso-right-usage",
  "viewBox": "0 0 17 17",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 17 17\" id=\"icon-sso-right\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"m10.305 13.241 3.771-3.771a.667.667 0 0 0 0-.943l-3.771-3.771a.667.667 0 1 0-.943.943l2.633 2.633H3.167a.667.667 0 0 0 0 1.333h8.828l-2.633 2.633a.667.667 0 1 0 .943.943Z\" fill=\"#4C556C\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol